import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonText } from '@ionic/angular/standalone';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PuzzleWinDialogInjectableInterface } from '../../shared-module/puzzle-win-dialog/puzzle-win-dialog-injectable.interface';
import { PuzzleWinDialogService } from '../../shared-module/puzzle-win-dialog/puzzle-win-dialog.service';
import { PuzzleFrameworkService } from '../../puzzle-framework-module/puzzle-framework.service';
import { PuzzleTimeRecordState } from '../../store/puzzle-time-record.state';
import { PuzzleTimeRecordModel } from '../../store/puzzle-time-record.model';

@Component({
  selector: 'lib-app-word-guess-puzzle-win-screen',
  templateUrl: './word-guess-puzzle-win-screen.component.html',
  styleUrls: ['./word-guess-puzzle-win-screen.component.scss'],
  standalone: true,
  imports: [CommonModule, IonText, TranslateModule],
})
export class WordGuessPuzzleWinScreenComponent implements PuzzleWinDialogInjectableInterface, OnDestroy {
  data: {
    solved: boolean;
    solution: string;
    solutionOriginal?: string;
    guessCount: number;
    maxGuesses: number;
  };

  duration: string;
  translationKey: string;

  private timeRecordSubscription: Subscription;
  private puzzleIDSubscription: Subscription;

  constructor(
    private store: Store,
    private framework: PuzzleFrameworkService,
    private winScreenService: PuzzleWinDialogService,
    private translateService: TranslateService
  ) {
    this.puzzleIDSubscription = this.store
      .select((state) => state.puzzleID)
      .subscribe((puzzleID) => {
        this.timeRecordSubscription = this.store
          .select(PuzzleTimeRecordState.getTimeRecordByID)
          .pipe(map((filterFn) => filterFn(puzzleID)))
          .subscribe((timeRecord: PuzzleTimeRecordModel) => {
            this.duration = timeRecord?.timeRecord?.timeString;
          });
      });

    this.translationKey = this.framework.getTranslationKey();
  }

  ngOnDestroy(): void {
    this.puzzleIDSubscription?.unsubscribe();
    this.timeRecordSubscription?.unsubscribe();
  }

  public setData(data: any) {
    this.data = data;

    /*
     * The dialog is shared between winning and losing, so the title is chosen here rather
     * than by the framework default.
     */
    const titleKey = `${this.translationKey}.win_dialog.${data.solved ? 'title' : 'title_lost'}`;

    void this.translateService
      .get(titleKey)
      .toPromise()
      .then((title) => {
        this.winScreenService.setTitle(title);
      });
  }

  get displaySolution(): string {
    return this.data?.solutionOriginal || this.data?.solution || '';
  }
}
